import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "axios";
const getTreatments = (axios, clinicReferenceId, employeeReferenceId) => async () => {
  const params = {
    clinicReferenceId,
    ...employeeReferenceId && {
      employeeReferenceId
    }
  };
  const { data } = await axios.get("/api/v1/internal/bookable-treatments", {
    params
  });
  return data ?? [];
};
const useTreatments = ({ clinicReferenceId, employeeReferenceId, disabled }) => {
  const { echoCore, auth } = useAxiosProvider();
  const queryKey = useMemo(() => ["bookable-treatments"], []);
  const enabled = !disabled && !!clinicReferenceId && !!auth;
  const { data, ...queryResult } = useQuery({
    queryKey,
    queryFn: getTreatments(echoCore, clinicReferenceId, employeeReferenceId),
    keepPreviousData: false,
    enabled
  });
  return {
    queryKey,
    queryResult,
    data
  };
};
export {
  useTreatments
};
